<template>
<div class="blog-wrapper">
  <div class="blog">
    <div class="blog-header">
      <img class="logo" src="/logo.svg" alt="">
      <div class="title">
        {{ post.title }}
      </div>
      <div class="date">
        {{ moment(post.created_at).format("MMMM DD, YYYY") }}
      </div>
    </div>
    <div
      class="blog-image"
      :style="{ backgroundImage: `url(${post.imageUrl})` }" />
    <div class="blog-posts">
      <div v-html="post.content"></div>
    </div>
  </div>
  <Footer/>
</div>
</template>
<script>
import Footer from '@/components/Footer.vue';
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('blog');
export default {
  data() {
    return {
      moment,
    };
  },
  components: {
    Footer,
  },
  computed: {
    ...mapState([
      'post',
    ]),
  },
  methods: {
    ...mapActions([
      'getPost',
    ]),
  },
  mounted() {
    const { postId } = this.$route.params;
    this.getPost(postId);
    moment.locale('es');
  },
};
</script>
<style lang="scss" scoped>
.blog-wrapper {
  height: 100vh;
  background-color: white;
  font-family: 'Inter';
  padding: 80px 0 0 0;
}
.blog {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.blog-header {
  background-color: white;
  width: 900px;
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.logo {
  width: 100px;
  margin-bottom: 20px;
}
.title {
  text-align: center;
  font-weight: bolder;
  font-size: 38px;
}
.date {
  text-align: center;
  margin-top: 20px;
}
.blog-image {
  width: 900px;
  height: 400px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.blog-posts {
  background-color: white;
  width: 800px;
  padding: 30px 20px 60px 20px;
}
.blog-section {
  width: 100%;
  margin-bottom: 20px;
  font-weight: bolder;
  text-transform: uppercase;
  font-size: 24px;
}
.blog-post {
  height: 300px;
  width: 40%;
  min-width: 45%;
  background-image: url("/background.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  cursor: pointer;
  padding: 24px;
}
.post-date {
  background-color: white;
  font-size: 16px;
  width: fit-content;
  padding: 4px 8px;
  margin-bottom: 25%;
}
.post-name {
  font-size: 26px;
  color: white;
  background-color: #2c70c1;
  padding: 8px 12px;
  font-weight: bolder;
  text-transform: uppercase;
  width: fit-content;
}
.post-summary {
  background-color: white;
  font-size: 20px;
  width: fit-content;
  padding: 4px 8px;
}
/deep/ strong {
  font-weight: bold;
}
/deep/ h1 {
  font-size: 2rem;
  margin: 2rem 0 1rem 0;
}
/deep/ h2 {
  font-size: 1.6rem;
  margin: 1rem 0;
}
/deep/ h3 {
  font-size: 1.4rem;
  margin: 1rem 0;
}
/deep/ p {
  margin: 1rem 0;
  text-align: justify !important;
  white-space: normal;
}
/deep/ pre {
  padding: 0.7rem 1rem;
  border-radius: 5px;
  background: black;
  color: white;
  font-size: 0.8rem;
  overflow-x: auto;

  /deep/ code {
    display: block;
  }
}
/deep/ * {
  caret-color: currentColor;
  line-height: 1.5;
  font-family: 'Inter';
}
/deep/ p code {
  display: inline-block;
  padding: 0 0.4rem;
  border-radius: 5px;
  font-size: 0.8rem;
  font-weight: bold;
  background: rgba(black, 0.1);
  color: rgba(black, 0.8);
}
/deep/ ul,
/deep/ ol {
  padding-left: 1rem;
}
/deep/ li > p,
/deep/ li > ol,
/deep/ li > ul {
  margin: 0;
}
/deep/ a {
  color: inherit;
}
/deep/ blockquote {
  border-left: 3px solid rgba(black, 0.1);
  color: rgba(black, 0.8);
  padding-left: 0.8rem;
  font-style: italic;

  p {
    margin: 0;
  }
}
/deep/ img {
  max-width: 100%;
  border-radius: 3px;
}
/deep/ table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin: 0;
  overflow: hidden;
}
/deep/ td, /deep/ th {
  min-width: 1em;
  border: 1px solid rgb(206, 205, 205);
  padding: 3px 5px;
  vertical-align: top;
  box-sizing: border-box;
  position: relative;
}
/deep/ td > * {
  margin-top: 0;
  margin-bottom: 0;
}
/deep/ th > * {
  margin-top: 0;
  margin-bottom: 0;
}
/deep/ th {
  font-weight: bold;
  text-align: left;
}

/deep/ figure {
  width: 100%;
  text-align: center;

  img {
    width: 50%;
    height: auto;
  }
}
/deep/ img {
  width: 50%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
@media only screen and (max-width: 1200px) {
  .blog-header {
    width: 100%;
  }
  .blog-posts {
    width: 100%;
  }
}
@media only screen and (max-width: 900px) {
  .blog-posts {
  }
  .blog-post {
    width: 900%;
    margin-bottom: 30px;
  }
}
</style>

